import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoMessageComponent } from './components/info-message/info-message.component';
import { SharedModule } from '@shared/shared.module';


@NgModule({
	declarations: [
		InfoMessageComponent
	],
	imports: [
		CommonModule,
		SharedModule
	], exports: [
		InfoMessageComponent
	]
})
export class InfoMessageModule {
}
